/**
 * @desc 保存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ChangeOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
